import { render, staticRenderFns } from "./EquipesDataTable.vue?vue&type=template&id=20889c88&scoped=true"
import script from "./EquipesDataTable.vue?vue&type=script&lang=js"
export * from "./EquipesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20889c88",
  null
  
)

export default component.exports